import type {
  Category,
  StrategyDetailItem,
} from '@/sections/visual-strategy/types';

type VisualStrategyDetailsProps = {
  details: Category['strategyDetails'];
};

const isVisibleDetailEntry = (item: StrategyDetailItem) =>
  item.value !== undefined && item.value !== null;

const sortDetailEntries = (a: { order?: number }, b: { order?: number }) => {
  const aOrder =
    typeof a.order === 'number' ? a.order : Number.MAX_SAFE_INTEGER;
  const bOrder =
    typeof b.order === 'number' ? b.order : Number.MAX_SAFE_INTEGER;

  return aOrder - bOrder;
};

const VisualStrategyDetails = ({ details }: VisualStrategyDetailsProps) => {
  const strategyDetailEntries: StrategyDetailItem[] = (details.data ?? [])
    .filter(isVisibleDetailEntry)
    .sort(sortDetailEntries);
  const riskScaleMax =
    typeof details.riskScaleMax === 'number' &&
    Number.isFinite(details.riskScaleMax)
      ? details.riskScaleMax
      : 5;

  return (
    <div className="mt-7">
      <div className="border-b border-white/20 px-0 py-3 text-sm font-semibold">
        {details.title}
      </div>

      <dl className="py-2 text-sm">
        {strategyDetailEntries.map(({ key, name, value }) => (
          <div
            key={key}
            className="flex items-center justify-between border-b border-white/20 py-2 last:border-b-0"
          >
            <dt className="text-white">{name ?? key}</dt>
            <dd className="text-right">
              {key === 'equityRiskLevel' ? (
                <span className="inline-flex items-center gap-1">
                  {Array.from({ length: riskScaleMax }).map((_, idx) => (
                    <span
                      key={`risk-${idx}`}
                      className={`inline-block h-2.5 w-2.5 rounded-full ${
                        idx < Number(value) ? 'bg-green-100' : 'bg-neutral-0'
                      }`}
                    />
                  ))}
                </span>
              ) : (
                String(value)
              )}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
};

export default VisualStrategyDetails;
